(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-all-blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ARROW_PREV = '<svg width="7" height="12" viewBox="0 0 8 14" fill="none" aria-hidden="true" focusable="false"><path d="M7 1L1 7l6 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const ARROW_NEXT = '<svg width="7" height="12" viewBox="0 0 8 14" fill="none" aria-hidden="true" focusable="false"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function initAllBlogPosts(root) {
      if (!root || root.dataset.paginationInit) return;
      root.dataset.paginationInit = 'true';

      const list = root.querySelector('[data-blog-grid]');
      const nav = root.querySelector('[data-blog-pagination]');
      const size = parseInt(root.dataset.pageSize, 10) || 15;
      const items = Array.prototype.slice.call(list.children);
      const pages = Math.ceil(items.length / size);
      if (pages < 2) return;

      function pageFromUrl() {
        const page = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;
        return Math.min(Math.max(page, 1), pages);
      }

      let current = pageFromUrl();

      function pageUrl(page) {
        const url = new URL(window.location.href);
        if (page === 1) url.searchParams.delete('page');
        else url.searchParams.set('page', page);
        return url.pathname + url.search;
      }

      function arrow(page, label, icon, enabled) {
        if (!enabled) return '<span class="blog-pagination__arrow is-disabled" aria-hidden="true">' + icon + '</span>';
        return '<a href="' + pageUrl(page) + '" class="blog-pagination__arrow" data-page="' + page + '" aria-label="' + label + '">' + icon + '</a>';
      }

      // First two pages, the last page and the pages around the current one; null marks a gap
      function visibleParts() {
        const shown = {};
        [1, 2, pages, current - 1, current, current + 1].forEach(function (n) {
          if (n >= 1 && n <= pages) shown[n] = true;
        });
        const numbers = Object.keys(shown).map(Number).sort(function (a, b) { return a - b; });
        const parts = [];
        numbers.forEach(function (n, i) {
          if (i > 0 && n - numbers[i - 1] > 1) parts.push(null);
          parts.push(n);
        });
        return parts;
      }

      function render() {
        items.forEach(function (item, i) {
          item.hidden = Math.floor(i / size) + 1 !== current;
        });

        let html = arrow(current - 1, 'Previous page', ARROW_PREV, current > 1) + '<ol class="blog-pagination__list">';
        visibleParts().forEach(function (part) {
          if (part === null) {
            html += '<li><span class="blog-pagination__page is-gap" aria-hidden="true">…</span></li>';
          } else if (part === current) {
            html += '<li><span class="blog-pagination__page is-current" aria-current="page" aria-label="Page ' + part + '">' + part + '</span></li>';
          } else {
            html += '<li><a href="' + pageUrl(part) + '" class="blog-pagination__page" data-page="' + part + '" aria-label="Page ' + part + '">' + part + '</a></li>';
          }
        });
        html += '</ol>' + arrow(current + 1, 'Next page', ARROW_NEXT, current < pages);

        nav.innerHTML = html;
        nav.hidden = false;
      }

      nav.addEventListener('click', function (event) {
        const link = event.target.closest('a[data-page]');
        if (!link) return;
        event.preventDefault();
        current = parseInt(link.dataset.page, 10);
        window.history.pushState({ page: current }, '', pageUrl(current));
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      window.addEventListener('popstate', function () {
        current = pageFromUrl();
        render();
      });

      render();
    }

    function initAll() {
      document.querySelectorAll('[data-all-blog-posts]').forEach(initAllBlogPosts);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-announcement-bar"]) return;
  try {
    

  function initAnnBar() {

    if (typeof Flickity === 'undefined') {
        console.warn('Flickity is not loaded yet, retryingf for annbar...');
        setTimeout(initAnnBar, 100);
      return;
    }

    function annBar() {
      let annBar = document.querySelector(".announcement-bar"),
        annClose = document.querySelector(".announcement-bar .js-close"),
        slider = document.querySelector(".announcement-bar__carousel"),
        html = document.querySelector("html"),
        bannerCheck = html.classList.contains("show-banner");

      if (sessionStorage.hasOwnProperty("annHide")) {
        console.log("banner previously hidden");
        html.classList.remove("show-banner");
        annBar.style.display = "none";
      } else {
        if (bannerCheck) {
          // html.classList.add('show-banner')
          // console.log("banner already showing");

          if (slider) {
            var flkty = new Flickity(slider, {
              wrapAround: true,
              prevNextButtons: false,
              cellSelector: ".announcement-bar__cell",
              autoPlay: 4000,
              pageDots: false,
              setGallerySize: false,
              draggable: false,
              fade: true,
            });
          }

          annClose.addEventListener("click", function (event) {
            event.preventDefault();

            html.classList.remove("show-banner");
            annBar.style.display = "none";

            window.sessionStorage.setItem("annHide", "true");
            window.sessionStorage.setItem("origin", "https://varana.com");
          });
        }
      }
    } 
  annBar();
}

initAnnBar();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ingredients-multi"] && !Shopify.designMode) return;
  try {
    
  function initIngredients() {

    if (typeof Flickity === 'undefined') {
      console.warn('Flickity is not loaded yet, retryingf for ingredients...');
      setTimeout(initIngredients, 100);
      return;
    }

    const mq = window.matchMedia("(min-width: 1084px)");
    let carousel = document.querySelector(".ingredients__carousel"),
        regularList = document.querySelector(".ingredients__list ul"),
        logs = true;

    function ingredientsCarousel(carousel) {
      if (!carousel) {
        console.warn("No ingredients carousel found");
        return;
      }
      
      let details = document.querySelector(".ingredients__list__details"),
          multiCheck = carousel.classList.contains("ingredients-multi__carousel");

      if (multiCheck && logs) {
        console.log("ingredients carousel exists");
        console.log("ingredients details exists");
      }
      
      var ingredientsFlkty = new Flickity(carousel, {
        wrapAround: true,
        cellAlign: "center",
        prevNextButtons: false,
        cellSelector: ".ingredients-card",
        pageDots: false,
        draggable: true,
      });

      ingredientsFlkty.on("change", function (index) {
        let currentSlide = ingredientsFlkty.selectedElement,
            currentHandle = currentSlide.dataset.ingredient,
            currentDetails = details.querySelector(
              `[data-ingredient="${currentHandle}"]`
            );

      details.querySelectorAll(".ingredients-details__item").forEach((item) => {
        item.classList.remove("is-active");
      });

        currentDetails.classList.add("is-active");
      });

      if (logs) {
        console.log("ingredients carousel inline script loaded");
      }
    }

    function ingredientsSelect(carousel) {
      if (!carousel) {
        console.warn("No ingredients carousel found, defaulting to inline select");
      }
      let list = carousel ? carousel : document.querySelector(".ingredients__list ul"),
          details = document.querySelector(".ingredients__list__details"),
          listItems = list.querySelectorAll(".ingredients-card__image"),
          detailsItems = details.querySelectorAll(".ingredients-details__item"),
          multiCheck = list.classList.contains("ingredients-multi__carousel");

        if (multiCheck) {
          
          if (listItems.length > 0) {
            console.log("ingredients select list items found");
            listItems[0].closest(".ingredients-card").classList.add("is-active");
          }
          if (detailsItems.length > 0) {
            console.log("ingredients select details items found");
            detailsItems[0].classList.add("is-active");
          }
        }

      listItems.forEach((item) => {
        item.addEventListener("click", function (event) {
          let card = item.closest(".ingredients-card"),
            handle = card.dataset.ingredient;

            console.log("Ingredient clicked:", handle);
          listItems.forEach((item) => {
            item.closest(".ingredients-card").classList.remove("is-active");
          });

          detailsItems.forEach((item) => {
            item.classList.remove("is-active");
          });

          card.classList.add("is-active");

          detailsItems.forEach((item) => {
            if (item.dataset.ingredient === handle) {
              item.classList.add("is-active");
            }
          });
        });
      });

        if (logs) {
          console.log("ingredients select inline script loaded");
        }
    }

    if (!mq.matches) { 
      ingredientsCarousel(carousel);
    } else {
      ingredientsSelect(carousel);
    }
  }
  
  initIngredients();

  window.addEventListener("resize", function() {
    const mq = window.matchMedia("(min-width: 1084px)");
    let carousel = document.querySelector(".ingredients__carousel");

    if (mq.matches) {
      if (carousel.classList.contains("flickity-enabled")) {
        carousel.flickityInstance.destroy();
      }
      ingredientsSelect(carousel);
    } else {
      ingredientsCarousel(carousel);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ingredients"] && !Shopify.designMode) return;
  try {
    

  function initIngredients() {

    if (typeof Flickity === 'undefined') {
      console.warn('Flickity is not loaded yet, retryingf for ingredients...');
      setTimeout(initIngredients, 100);
      return;
    }

    const mq = window.matchMedia("(min-width: 1084px)");
    let carousel = document.querySelector(".ingredients__carousel"),
        regularList = document.querySelector(".ingredients__list ul"),
        logs = true;

    function ingredientsCarousel(carousel) {
      if (!carousel) {
        console.warn("No ingredients carousel found");
        return;
      }
      
      let details = document.querySelector(".ingredients__list__details"),
          multiCheck = carousel.classList.contains("ingredients-multi__carousel");

      if (multiCheck && logs) {
        console.log("ingredients carousel exists");
        console.log("ingredients details exists");
      }
      
      var ingredientsFlkty = new Flickity(carousel, {
        wrapAround: true,
        cellAlign: "center",
        prevNextButtons: false,
        cellSelector: ".ingredients-card",
        pageDots: false,
        draggable: true,
      });

      ingredientsFlkty.on("change", function (index) {
        let currentSlide = ingredientsFlkty.selectedElement,
            currentHandle = currentSlide.dataset.ingredient,
            currentDetails = details.querySelector(
              `[data-ingredient="${currentHandle}"]`
            );

      details.querySelectorAll(".ingredients-details__item").forEach((item) => {
        item.classList.remove("is-active");
      });

        currentDetails.classList.add("is-active");
      });

      // Initialize first detail item as active
      let firstDetails = details.querySelector(".ingredients-details__item");
      if (firstDetails) {
        firstDetails.classList.add("is-active");
      }

      if (logs) {
        console.log("ingredients carousel inline script loaded");
      }
    }

    function ingredientsSelect(carousel) {
      if (!carousel) {
        console.warn("No ingredients carousel found, defaulting to inline select");
      }
      let list = carousel ? carousel : document.querySelector(".ingredients__list ul"),
          details = document.querySelector(".ingredients__list__details"),
          listItems = list.querySelectorAll(".ingredients-card__image"),
          detailsItems = details.querySelectorAll(".ingredients-details__item"),
          multiCheck = list.classList.contains("ingredients-multi__carousel");

        if (multiCheck) {
          
          if (listItems.length > 0) {
            console.log("ingredients select list items found");
            listItems[0].closest(".ingredients-card").classList.add("is-active");
          }
          if (detailsItems.length > 0) {
            console.log("ingredients select details items found");
            detailsItems[0].classList.add("is-active");
          }
        }

      listItems.forEach((item) => {
        item.addEventListener("click", function (event) {
          let card = item.closest(".ingredients-card"),
            handle = card.dataset.ingredient;

            console.log("Ingredient clicked:", handle);
          listItems.forEach((item) => {
            item.closest(".ingredients-card").classList.remove("is-active");
          });

          detailsItems.forEach((item) => {
            item.classList.remove("is-active");
          });

          card.classList.add("is-active");

          detailsItems.forEach((item) => {
            if (item.dataset.ingredient === handle) {
              item.classList.add("is-active");
            }
          });
        });
      });

        if (logs) {
          console.log("ingredients select inline script loaded");
        }
    }

    if (!mq.matches) { 
      ingredientsCarousel(carousel);
    } else {
      ingredientsSelect(carousel);
    }
  }
  
  initIngredients();

  window.addEventListener("resize", function() {
    const mq = window.matchMedia("(min-width: 1084px)");
    let carousel = document.querySelector(".ingredients__carousel");

    if (mq.matches) {
      if (carousel.classList.contains("flickity-enabled")) {
        carousel.flickityInstance.destroy();
      }
      ingredientsSelect(carousel);
    } else {
      ingredientsCarousel(carousel);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-simple-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function initSimpleRowCarousel(row) {
      if (!row || row.dataset.carouselInit) return;
      const list = row.querySelector(".simple-row__list");
      const prev = row.querySelector("[data-simple-row-prev]");
      const next = row.querySelector("[data-simple-row-next]");
      if (!list || !prev || !next) return;
      row.dataset.carouselInit = "true";

      const step = (direction) => {
        const card = list.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        list.scrollBy({
          left: direction * distance,
          behavior: reduceMotion.matches ? "auto" : "smooth"
        });
      };

      prev.addEventListener("click", () => step(-1));
      next.addEventListener("click", () => step(1));

      const first = list.firstElementChild;
      const last = list.lastElementChild;
      if (!first || !last || typeof IntersectionObserver !== "function") {
        prev.disabled = false;
        return;
      }

      // Button state from observers: no scroll listener, no layout reads.
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const atEdge = entry.intersectionRatio >= 0.95;
            if (entry.target === first) prev.disabled = atEdge;
            if (entry.target === last) next.disabled = atEdge;
          });
        },
        { root: list, threshold: [0, 0.95] }
      );
      observer.observe(first);
      if (last !== first) observer.observe(last);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(".simple-row--carousel").forEach(initSimpleRowCarousel);
    }

    initAll();
    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
